import { ProductTypes } from './types';

const intermediacoesAP = [
  0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 12.0, 13.0,
  14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0, 23.0, 24.0, 25.0, 26.0,
  27.0, 28.0, 29.0, 30.0, 31.0, 32.0, 33.0, 34.0, 35.0, 36.0, 37.0, 38.0, 39.0,
  40.0, 41.0, 42.0, 43.0, 44.0, 45.0, 46.0, 47.0, 48.0, 49.0
];

const intermediacoesVI = [
  0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 12.0, 13.0,
  14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0, 23.0, 24.0, 25.0, 26.0,
  27.0, 28.0, 29.0, 30.0, 31.0, 32.0, 33.0, 34.0, 35.0, 36.0, 37.0, 38.0, 39.0,
  40.0, 41.0, 42.0, 43.0, 44.0, 45.0
];

const intermediacoesVF = [
  0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 12.0, 13.0,
  14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0, 23.0, 24.0, 25.0, 26.0,
  27.0, 28.0, 29.0, 30.0, 31.0, 32.0, 33.0, 34.0, 35.0, 36.0, 37.0, 38.0, 39.0,
  40.0, 41.0, 42.0, 43.0, 44.0, 45.0
];
const listaComissionamentos = [
  //dados remuneracao ap
  {
    produto: 6994880490,
    identifier: 'acidentes_pessoais',
    percentuais_remuneracao: [
      {
        comissao: 1.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 2.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 3.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 4.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 5.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 6.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 7.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 8.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 9.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 10.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 11.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 12.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 13.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 14.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 15.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 16.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 17.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 18.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 19.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 20.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 21.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 22.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 23.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 24.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 25.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 26.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 27.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 28.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 29.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 30.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 31.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 32.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 33.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 34.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 35.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 36.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 37.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 38.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 39.0,
        agenciamentos: [0.0, 50.0, 100.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 40.0,
        agenciamentos: [0.0, 50.0, 100.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 41.0,
        agenciamentos: [0.0, 50.0, 100.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 42.0,
        agenciamentos: [0.0, 50.0, 100.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 43.0,
        agenciamentos: [0.0, 50.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 44.0,
        agenciamentos: [0.0, 50.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 45.0,
        agenciamentos: [0.0, 50.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 46.0,
        agenciamentos: [0.0, 50.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 47.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 48.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 49.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesAP
      },
      {
        comissao: 50.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesAP
      }
    ]
  },

  //dados remuneracao vi
  {
    produto: 1181397586,
    identifier: 'vida_individual',
    percentuais_remuneracao: [
      {
        comissao: 1.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 2.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 3.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 4.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 5.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 6.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 7.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 8.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 9.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 10.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 11.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 12.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 13.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 14.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 15.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 16.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 17.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 18.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 19.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 20.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 21.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 22.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 23.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 24.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 25.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 26.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 27.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 28.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 29.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 30.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 31.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 32.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 33.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 34.0,
        agenciamentos: [0.0, 50.0, 100.0, 150.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 35.0,
        agenciamentos: [0.0, 50.0, 100.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 36.0,
        agenciamentos: [0.0, 50.0, 100.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 37.0,
        agenciamentos: [0.0, 50.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 38.0,
        agenciamentos: [0.0, 50.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 39.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 40.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 41.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 42.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 43.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 44.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesVI
      },
      {
        comissao: 45.0,
        agenciamentos: [0.0],
        intermediacoes: intermediacoesVI
      },
      { comissao: 46.0, agenciamentos: [0.0], intermediacoes: intermediacoesVI }
    ]
  },

  // dados remuneracao vf
  process.env.REACT_APP_environment === 'master'
    ? {
        produto: 7986106960,
        identifier: 'vida_flex',
        percentuais_remuneracao: [
          {
            comissao: 1.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 2.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 3.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 4.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 5.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 6.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 7.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 8.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 9.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 10.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 11.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 12.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 13.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 14.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 15.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 16.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 17.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 18.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 19.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 20.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 21.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 22.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 23.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 24.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 25.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 26.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 27.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 28.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 29.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 30.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 31.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 32.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 33.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 34.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 35.0,
            agenciamentos: [0.0, 50.0, 100.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 36.0,
            agenciamentos: [0.0, 50.0, 100.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 37.0,
            agenciamentos: [0.0, 50.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 38.0,
            agenciamentos: [0.0, 50.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 39.0,
            agenciamentos: [0.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 40.0,
            agenciamentos: [0.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 41.0,
            agenciamentos: [0.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 42.0,
            agenciamentos: [0.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 43.0,
            agenciamentos: [0.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 44.0,
            agenciamentos: [0.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 45.0,
            agenciamentos: [0.0],
            intermediacoes: intermediacoesVF
          },
          {
            comissao: 46.0,
            agenciamentos: [0.0],
            intermediacoes: intermediacoesVF
          }
        ]
      }
    : {
        produto: 40529084990,
        identifier: 'vida_flex',
        percentuais_remuneracao: [
          {
            comissao: 1.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 2.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0, 300.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 3.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 4.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 5.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 6.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 7.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 8.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 9.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 10.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 11.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 12.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 13.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 14.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 15.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 16.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 17.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 18.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 19.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 20.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 21.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 22.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 23.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 24.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 25.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 26.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 27.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 28.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 29.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 30.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0, 200.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 31.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 32.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 33.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 34.0,
            agenciamentos: [0.0, 50.0, 100.0, 150.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 35.0,
            agenciamentos: [0.0, 50.0, 100.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 36.0,
            agenciamentos: [0.0, 50.0, 100.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 37.0,
            agenciamentos: [0.0, 50.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 38.0,
            agenciamentos: [0.0, 50.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 39.0,
            agenciamentos: [0.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 40.0,
            agenciamentos: [0.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 41.0,
            agenciamentos: [0.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 42.0,
            agenciamentos: [0.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 43.0,
            agenciamentos: [0.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 44.0,
            agenciamentos: [0.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 45.0,
            agenciamentos: [0.0],
            intermediacoes: [0.0]
          },
          {
            comissao: 46.0,
            agenciamentos: [0.0],
            intermediacoes: [0.0]
          }
        ]
      }
];

export const getListaCorretagensByProductType = (
  produtctType: ProductTypes
) => {
  console.log('tipo produto', produtctType);
  return (
    listaComissionamentos
      .filter((el, _) => {
        if (el.identifier == produtctType) {
          return true;
        }
      })[0]
      ?.percentuais_remuneracao.map((dadosComissao, _) => {
        return dadosComissao.comissao;
      })
      ?.sort((a, b) => {
        return a - b;
      }) || []
  );
};

export const getAgenciamentoByCorretagemAndProdType = (
  produtctType: ProductTypes,
  percentualCorretagem: number
) => {
  return (
    listaComissionamentos
      .filter((el, _) => {
        if (el.identifier == produtctType) {
          return true;
        }
      })[0]
      ?.percentuais_remuneracao.filter((dadosComissao, _) => {
        return dadosComissao.comissao == percentualCorretagem;
      })[0]?.agenciamentos || []
  );
};

export const getIntermediacaoByCorretagem = (percentualCorretagem: number) => {
  return new Array(percentualCorretagem).fill(0).map((_, index) => index);
};

export const getMaxValueCorretagem = (produtctType: ProductTypes) => {
  const valores = listaComissionamentos
    .filter((el, _) => {
      if (el.identifier == produtctType) {
        return true;
      }
    })[0]
    ?.percentuais_remuneracao.map((dadosComissao, _) => {
      return dadosComissao.comissao;
    });

  const maxValue = valores?.reduce((acc, cur) => acc + cur, 0);

  return maxValue;
};
